import axios, { AxiosResponse } from 'axios' 
import { IMaintenanceModel } from './ServiceMaintenanceModel'
import { ApiResponse, PageResponse } from '../../../../shared/models/ApiModels'


const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

export const MAINTENANCE_CREATE_URL = `${API_URL}api/v1/definition/maintenance/create`
export const MAINTENANCE_GET_ALL_URL = `${API_URL}api/v1/definition/maintenance/all`
export const MAINTENANCE_DELETE_URL = `${API_URL}api/v1/definition/maintenance/delete/`
export const MAINTENANCE_UPDATE_URL = `${API_URL}api/v1/definition/maintenance/update/`

export function createMaintenance(maintenance: IMaintenanceModel) {
  return axios.post(MAINTENANCE_CREATE_URL, maintenance)
}

export async function loadMaintenances(
  page = 0, 
  size = 5, 
  sort: string = 'createdDate', 
  order: string = 'desc'
): Promise<AxiosResponse<ApiResponse<PageResponse<IMaintenanceModel>>>> {
  return axios.get(MAINTENANCE_GET_ALL_URL, {
    params: { page, size, sort, order }
  });
}

export function deleteMaintenance(maintenanceId: String) {
  return axios.post(MAINTENANCE_DELETE_URL + maintenanceId)
}

export function updateMaintenance(maintenance: IMaintenanceModel) {
  return axios.post(MAINTENANCE_UPDATE_URL + maintenance.id, maintenance)
}

 
